import { Notifier } from '@airbrake/browser';

const airbrake = new Notifier({
    projectId: 436906,
    projectKey: '4425e89e31110edfafd1a22690da246c',
    environment: 'production',
});

// Global error catching:
window.addEventListener('error', function (event) {
    airbrake.notify({
        error: event.error,
        context: { component: 'window' }
    });
});

// It is also possible to intercept unhandled promise rejections:
window.addEventListener('unhandledrejection', function (event) {
    airbrake.notify({
        error: event.reason,
        context: { component: 'Promise' }
    });
});
